var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Input from '@rad/components/inputs/input';
import ActionButton from '@rad/components/ui/action-button';
import { getCommunityAdmins, addCommunityAdmin, revokeCommunityInvite, } from '../../../common/network/system';
import { useToast } from '../../../contexts/toast';
const adminMessages = {
    'added': 'They are now an administrator.',
    'invited': 'Invitation sent. They become an administrator as soon as they create their account.',
    'role-added': 'Their pending invitation now makes them an administrator, and was sent again.',
    'already-invited': 'That email already has a pending invitation to be an administrator.',
};
/**
 * Who administers a community (holds its Owner role), and naming another. Removing one is done
 * from the Users screen, where roles are edited. A district made before districts were given the
 * Owner role has none to give, and says so instead.
 */
const CommunityAdministrators = (props) => {
    const toast = useToast();
    const [data, setData] = useState(null);
    const [email, setEmail] = useState('');
    const load = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield getCommunityAdmins(props.communityId);
        if (res)
            setData(res);
    }), [props.communityId]);
    useEffect(() => { load(); }, [load]);
    const handleAdd = () => __awaiter(void 0, void 0, void 0, function* () {
        const [success, res] = yield addCommunityAdmin(props.communityId, email);
        load();
        if (success) {
            setEmail('');
            toast.success(adminMessages[res.status]);
        }
        else {
            toast.error(res.map(e => e.message).join('\n'));
        }
    });
    const handleRevoke = (inviteId) => __awaiter(void 0, void 0, void 0, function* () {
        yield revokeCommunityInvite(props.communityId, inviteId);
        load();
        toast.success('Invitation revoked');
    });
    if (!data)
        return _jsx(_Fragment, {});
    if (!data.hasOwnerRole) {
        return (_jsxs(_Fragment, { children: [_jsx("h6", { children: "Administrators" }), _jsx("p", { className: "text-muted small mb-0", children: "This district has no Owner role. Assign roles from the Users screen." })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("h6", { children: "Administrators" }), _jsx("p", { className: "text-muted small", children: "Administrators hold the Owner role, which carries every permission. If the email already has a 76UNBOXED account they become one immediately, otherwise they're invited and become one when they sign up. Remove one from the Users screen." }), _jsxs("div", { className: "d-flex align-items-end gap-2 mb-3", children: [_jsx(Input, { label: "Email", kind: "email", className: "flex-grow-1", value: email, onChange: setEmail }), _jsx(ActionButton, { className: "btn btn-primary", onClick: handleAdd, disabled: !email, loadingText: "Saving...", children: "Add administrator" })] }), data.admins.length === 0 && data.invites.length === 0 ? (_jsx("p", { className: "text-muted small mb-0", children: "No administrators yet." })) : (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Email" }), _jsx("th", {})] }) }), _jsxs("tbody", { children: [data.admins.map(a => (_jsxs("tr", { children: [_jsx("td", { children: `${a.firstName} ${a.lastName}`.trim() || _jsx("span", { className: "text-muted", children: "No name" }) }), _jsx("td", { children: a.email }), _jsx("td", {})] }, a.id))), data.invites.map(i => (_jsxs("tr", { children: [_jsx("td", { children: _jsx("span", { className: "badge bg-warning-subtle text-warning-emphasis", children: "Invited" }) }), _jsx("td", { children: i.email }), _jsx("td", { className: "text-end", children: _jsx("button", { className: "btn btn-sm btn-link text-danger", onClick: () => handleRevoke(i.id), children: "Revoke" }) })] }, i.id)))] })] }) }))] }));
};
export default CommunityAdministrators;
